import React from 'react';

export default function AvailabilityNoUser(props) {
	return (
		< li className="list-group-item py-3" >
			<span className="text-danger">Niemand beschikbaar</span>
		</li >
	)
}